import type { SmartFacet } from '../types'

/** Combine SMART facets into one narrative paragraph (not labeled S/M/A/R/T rows). */
export function smartFacetToParagraph(facet: SmartFacet): string {
  const parts = (
    [
      facet.specific,
      facet.measurable,
      facet.achievable,
      facet.relevant,
      facet.time_bound,
    ] as const
  )
    .map((s) => s.trim())
    .filter(Boolean)
  return parts.map((p) => (/[.!?…]$/.test(p) ? p : `${p}.`)).join(' ')
}

export function smartFacetsToParagraph(facets: SmartFacet[]): string {
  return facets.map(smartFacetToParagraph).filter(Boolean).join(' ')
}
